export const RELOAD_SERVER_SETTINGS_FAILURE = 'RELOAD_SERVER_SETTINGS_FAILURE';

export const reloadServerSettingsFailure = ( payload: Error ) => ({
    type: RELOAD_SERVER_SETTINGS_FAILURE,
    payload,
});